<!--***************************************
CREATED BY : Vekanth
Last Modified Date : 26/06/2018
**************************************/-->

<div class="row provider-search-row">
  <div class="col-md-12">
    <div class="cup-container">
      <div class="panel-body">
        <div class="row">
          <div class="row">
            @if (showProviderSearchError) {
              <div class="provider-search-error">
                <span>
                  You must enter a provider id or provider name or specialty
                  @if (fromAuthScreens) {
                    <span> or zip code/city</span>
                    } before
                    hitting the search button
                  </span>
                </div>
              }
              <div class="cup-disclaimer">
                <span class="symbol">*</span>
                <span>
                  You must enter "Provider ID" or " Provider Name" or "Specialty"
                  @if (fromAuthScreens) {
                    <span> or "Zip Code/City"</span>
                    } before
                    hitting the search button</span
                    >
                  </div>
                  <!--<div class="cup-disclaimer zip-disclaimer">
                  <span class="symbol">*</span><span>  You must type in atleast 3 characters in the Zipcode/City field to initiate the search</span>
                </div>-->
              </div>

              <div class="row">
                <form
                  [formGroup]="providerSearchForm"
                  (ngSubmit)="searchProviderData(providerSearchForm.value)"
                  autocomplete="on"
                  novalidate
                  >
                  <div class="row section-padding">
                    <div
                      class="form-group col-md-12"
                      [ngClass]="{ invalid: showProviderSearchError }"
                      >
                      <label for="providerId" (click)="$event.stopPropagation()"
                        ><span class="required">* </span>PROVIDER ID</label
                        >
                        <input
                          name="providerId"
                          id="providerId"
                          type="text"
                          class="form-control input-underline"
                          [(ngModel)]="providerId"
                          formControlName="providerIdFormControl"
                          placeholder="Enter Provider ID/Tax ID/NPI"
                          (click)="retainOnInputClick()"
                          />
                          @if (providerId) {
                            <a
                              class="icon-view"
                              href="javascript:void(0);"
                              tabindex="-1"
                              (click)="clearProviderId(); retainOnInputClick()"
                              >
                              <i class="fa fa-times" aria-hidden="true"></i>
                            </a>
                          }
                        </div>
                        <div
                          class="form-group col-md-12"
                  [ngClass]="{
                    invalid:
                      showProviderSearchError ||
                      providerSearchForm.controls[
                        'providerNameFormControl'
                      ].hasError('minlength')
                  }"
                          >
                          <label for="providerName" (click)="$event.stopPropagation()"
                            ><span class="required">* </span>NAME</label
                            >
                            <input
                              name="providerName"
                              id="providerName"
                              type="text"
                              class="form-control input-underline"
                              [(ngModel)]="providerName"
                              formControlName="providerNameFormControl"
                              placeholder="Enter Name "
                              minlength="2"
                              (click)="retainOnInputClick()"
                              />
                              @if (providerName) {
                                <a
                                  class="icon-view"
                                  href="javascript:void(0);"
                                  tabindex="-1"
                                  (click)="clearProviderName(); retainOnInputClick()"
                                  >
                                  <i class="fa fa-times" aria-hidden="true"></i>
                                </a>
                              }
                              @if (
                                !showProviderSearchError &&
                                providerSearchForm.controls[
                                'providerNameFormControl'
                                ].hasError('minlength')
                                ) {
                                <span
                                  class="name-err-msg"
                                  >
                                  You must enter atleast the first 2 characters of the
                                  Provider Name to perform a search</span
                                  >
                              }
                            </div>
                            <div
                              class="form-group col-md-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis cup-dd-down-arrow-search"
                              [ngClass]="{ invalid: showProviderSearchError }"
                              >
                              <label
                                for="providerSpecialty"
                                (click)="$event.stopPropagation()"
                                ><span class="required">* </span>SPECIALTY/PROVIDER
                                TYPE</label
                                >
                                <cup-autocomplete
                                  [autoCompleteDynamic]="true"
                                  class="form-control input-underline"
                                  [colWidth]="16"
                                  formControlName="providerSpecialtyFormControl"
                    [control]="
                      providerSearchForm.controls.providerSpecialtyFormControl
                    "
                                  [autoCompleteOptions]="SpecialityList"
                                  (autoCompleteModelChange)="onSpecialtyChange($event)"
                    title="{{
                      providerSearchForm?.controls?.providerSpecialtyFormControl
                        ?.value?.value
                    }}"
                                  [autoCompletePlaceholder]="specialtyPlaceholder"
                                  (click)="retainOnInputClick()"
                                ></cup-autocomplete>
                                <!--<label for="providerSpecialty" (click)="$event.stopPropagation()">SPECIALTY</label>
                                <a class="icon-view providerSpeciality" href="javascript:void(0);" tabindex="-1">
                                  <img src="assets/images/dropdownarrow.png" alt="view">
                                </a>
                                <input ngui-auto-complete [source]="SpecialityList" list-formatter="value" display-property-name="value" name="providerSpecialty"
                                  id="providerSpecialty" type="text" class="form-control input-underline" formControlName="providerSpecialtyFormControl"
                                  placeholder="Select Speciality" (click) = "retainOnInputClick()"/>-->
                                </div>
                              </div>
                              <div class="row section-padding">
                                <div
                                  class="form-group col-md-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
                                  >
                                  <label for="providerIPA" (click)="$event.stopPropagation()"
                                    >REGION</label
                                    >
                                    <cup-autocomplete
                                      [autoCompleteDynamic]="false"
                                      class="form-control input-underline"
                                      [colWidth]="16"
                                      formControlName="providerIPAFormControl"
                    [control]="
                      providerSearchForm.controls.providerIPAFormControl
                    "
                                      [autoCompleteOptions]="IPADataList"
                                      (autoCompleteModelChange)="onRegionChange($event)"
                                      title="{{ regionTitle }}"
                                      [autoCompletePlaceholder]="regionPlaceholder"
                                      (click)="retainOnInputClick()"
                    [autoCompleteModel]="
                      providerSearchForm.controls.providerIPAFormControl.value
                    "
                                    ></cup-autocomplete>
                                    <!--<a class="icon-view" href="javascript:void(0);" tabindex="-1">
                                    <img src="assets/images/dropdownarrow.png" alt="view">
                                  </a>
                                  <input ngui-auto-complete [source]="IPADataList" list-formatter="value" display-property-name="value" name="providerIPA"
                                    id="providerIPA" type="text" class="form-control input-underline" formControlName="providerIPAFormControl"
                                    placeholder="Select Region" (click) = "retainOnInputClick()"/>-->
                                  </div>

                                  <!--Second Row-->

                                  <div
                                    class="form-group col-md-12 zip-code"
                  [ngClass]="{
                    invalid:
                      zipcodeSearchError ||
                      (fromAuthScreens && showProviderSearchError)
                  }"
                                    >
                                    <label
                                      for="providerZipCode"
                                      title="Optional. Show provider distance from this zipcode/city"
                                      (click)="$event.stopPropagation()"
                                      >@if (fromAuthScreens) {
                                      <span class="required"
                                        >*&nbsp;</span
                                        >
                                      }ZIP CODE / CITY</label
                                      >

                                      <!-- <input ngui-auto-complete [source]="zipCode_ObservableSource.bind(this)" list-formatter="zipCode" display-property-name="zipCode" name="providerZipCode"
                                      id="providerZipCode" type="text"  class="form-control input-underline zip-code"
                                      formControlName="providerZipCodeFormControl" min-chars="3" placeholder="Enter ZIP CODE/CITY" [(ngModel)]="zipCode" (ngModelChange)="checkGeoDistance($event)" (click) = "retainOnInputClick()"
                                      /> -->
                                      @if (zipCode) {
                                        <a
                                          class="icon-view zip-clear"
                                          href="javascript:void(0);"
                                          tabindex="-1"
                                          (click)="retainOnInputClick()"
                                          >
                                          <i
                                            class="fa fa-times"
                                            aria-hidden="true"
                                            (click)="clearZipCode(); retainOnInputClick()"
                                          ></i>
                                        </a>
                                      }
                                      @if (zipcodeSearchError) {
                                        <span>
                                          Zipcode/City should be entered first</span
                                          >
                                        }
                                      </div>
                                      <div
                                        class="form-group col-md-12 zip-code cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
                                        >
                                        <label
                                          for="providerDistance"
                                          title="Distance in Miles"
                                          (click)="$event.stopPropagation()"
                                          >DIST FROM ZIP CODE / CITY</label
                                          >
                                          <cup-autocomplete
                                            [autoCompleteDynamic]="false"
                                            class="form-control input-underline"
                                            [colWidth]="16"
                                            formControlName="providerDistanceFormControl"
                    [control]="
                      providerSearchForm.controls.providerDistanceFormControl
                    "
                                            [autoCompleteOptions]="distanceInMiles"
                                            title="{{ milesDistance }}"
                                            [autoCompletePlaceholder]="distancePlaceholder"
                                            [autoCompleteModel]="milesDistance"
                                            (autoCompleteModelChange)="checkGeoDistance($event)"
                                            (click)="retainOnInputClick()"
                                          ></cup-autocomplete>
                                          <!--<select class="form-control input-underline distance-dropdown" formControlName="providerDistanceFormControl" [(ngModel)]="milesDistance" (ngModelChange)="checkGeoDistance()" (click) = "retainOnInputClick()">
                                          <option class="select-placeholder" disabled hidden [value]="selectUndefinedOptionValue">Select distance (in miles)</option>
                                          <option class="distance-dropdown-options" *ngFor="let distance of distanceInMiles" [selected]="distance.id==2" [ngValue]="distance.id">{{distance.value}}</option>
                                        </select>-->
                                        <!--<May be Needed in future-->
                                        <!--<input #dist ngui-auto-complete [source]="data" list-formatter="value" display-property-name="value"
                                        name="providerDistance" id="providerDistanceType" title="Distance in Miles"  type="number" min="0" class="form-control input-underline zip-distance"
                                        [formControl]="providerDistanceFormControl" placeholder="Select Distance (in miles)" [ngModel]="milesDistance" (ngModelChange)="checkGeoDistance()" />-->
                                        <!--<div>
                                        <label><input name="providerDistanceRadio" id="providerDistanceTypeAny" type="radio" [checked]="true" [formControl]="providerDistanceRadio" value="9999" (click)="setDistance(9999)">Any</label>
                                        <input name="providerDistanceRadio" id="providerDistanceType" type="radio" [formControl]="providerDistanceRadio" (click)="focusDistance()" value="distance" >
                                      </div>-->
                                    </div>
                                  </div>
                                  <div class="row section-padding">
                                    <div
                                      class="form-group col-md-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
                                      >
                                      <label
                                        for="providerNeighborhood"
                                        (click)="$event.stopPropagation()"
                                        >NEIGHBORHOOD</label
                                        >
                                        <cup-autocomplete
                                          [autoCompleteDynamic]="true"
                                          class="form-control input-underline"
                                          [colWidth]="16"
                                          formControlName="providerNeighborhoodFormControl"
                    [control]="
                      providerSearchForm.controls
                        .providerNeighborhoodFormControl
                    "
                                          [autoCompleteOptions]="NeighborhoodList"
                                          (autoCompleteModelChange)="onNeighborhoodChange($event)"
                                          title="{{ neighborhoodTitle }}"
                                          [autoCompletePlaceholder]="neighborhoodPlaceholder"
                                          (click)="retainOnInputClick()"
                    [autoCompleteModel]="
                      providerSearchForm.controls.providerNeighborhoodFormControl
                        .value
                    "
                                        ></cup-autocomplete>
                                        <!--<a class="icon-view" href="javascript:void(0);" tabindex="-1">
                                        <img src="assets/images/dropdownarrow.png" alt="view">
                                      </a>
                                      <input ngui-auto-complete [source]="NeighborhoodList" list-formatter="value" display-property-name="value" name="providerNeighborhood"
                                        id="providerNeighborhood" type="text" class="form-control input-underline" formControlName="providerNeighborhoodFormControl"
                                        placeholder="Select Neighborhood" (click) = "retainOnInputClick()"/>-->
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12 cup-panel-controls">
                                        <div class="pull-right button-right">
                                          <button
                                            type="submit"
                                            class="btn btn-primary"
                                            (click)="$event.stopPropagation()"
                                            >
                                            Search
                                            <span
                                              ><i class="fa fa-arrow-right" aria-hidden="true"></i
                                            ></span>
                                          </button>
                                          <button
                                            type="button"
                                            class="btn btn-secondary"
                                            (click)="$event.stopPropagation(); clearProviderData()"
                                            >
                                            Clear All
                                            <span
                                              ><i class="fa fa-times" aria-hidden="true"></i
                                            ></span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
